import { ALTITUDE_BANDS } from "../map/icons";
import { altitudeUnit, legendLabel, type Units } from "../units";

/** What the marker colours mean. Without it the palette is decoration; with it, "orange and
 *  close" reads as "low and near" at a glance, which is the question this app answers. */
export default function AltitudeLegend({ units }: { units: Units }) {
  return (
    <div className="legend" aria-label="Altitude colour key">
      {ALTITUDE_BANDS.map((band, i) => (
        <span key={band.color} className="legend-item">
          <span className="legend-swatch" style={{ background: band.color }} />
          {i === ALTITUDE_BANDS.length - 1
            ? `${legendLabel(ALTITUDE_BANDS[i - 1].max, units)}+`
            : legendLabel(band.max, units)}
        </span>
      ))}
      <span className="legend-unit">{altitudeUnit(units)}</span>
    </div>
  );
}
